// extracted by mini-css-extract-plugin
export var container = "_se-0";
export var inputWidth = "_se-1";